import { Avatar, Box, Stack } from '@mui/material'
// import { has, upperCase } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

// import DirIcon from './assets/ranks/dir.svg'
// import DstIcon from './assets/ranks/dst.svg'
// import EtcIcon from './assets/ranks/etc.svg'
// import ExdIcon from './assets/ranks/exd.svg'
// import ExmIcon from './assets/ranks/exm.svg'
// import MbrIcon from './assets/ranks/mbr.svg'
// import MgrIcon from './assets/ranks/mgr.svg'
// import PccIcon from './assets/ranks/pcc.svg'
// import PdiIcon from './assets/ranks/pdi.svg'
// import PrdIcon from './assets/ranks/prd.svg'
// import PrrIcon from './assets/ranks/prr.svg'
// import PrsIcon from './assets/ranks/prs.svg'
// import SrdIcon from './assets/ranks/srd.svg'
// import SrmIcon from './assets/ranks/srm.svg'
// import DiaIcon from './assets/ranks/pdi.svg'
import AvatarIcon from './assets/Avatar.svg'
import { IconSpinner } from '../Spinner/IconSpinner'

const GenealogyProfilePicture = observer(({ profileRankShort, profilePicture, isSuspended, avatarStyle = 'circle' }) => {
    const [image, setImage] = useState(null)

    const InitImage = () => {
        if (profilePicture) {
            setImage(profilePicture)
        } else {
            setImage(AvatarIcon)
            // if (profileRankShort) {
            //     if (upperCase(profileRankShort).replace(/\s/g, '') === 'DIR') {
            //         setImage(DirIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'DST') {
            //         setImage(DstIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'ETC') {
            //         setImage(EtcIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'EXD') {
            //         setImage(ExdIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'EXM') {
            //         setImage(ExmIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'MBR') {
            //         setImage(MbrIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'MGR') {
            //         setImage(MgrIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'PCC') {
            //         setImage(PccIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'PDI') {
            //         setImage(PdiIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'PRD') {
            //         setImage(PrdIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'PRR') {
            //         setImage(PrrIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'PRS') {
            //         setImage(PrsIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'SRD') {
            //         setImage(SrdIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'SRM') {
            //         setImage(SrmIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'ASC') {
            //         setImage(DstIcon)
            //     } else if (upperCase(profileRankShort).replace(/\s/g, '') === 'DIA') {
            //         setImage(DiaIcon)
            //     }
            // }
        }
    }

    useEffect(() => {
        InitImage()
    }, [profilePicture, profileRankShort])

    return (
        <Stack
            sx={{
                boxShadow: profilePicture ? '0px 0px 3px 0px rgba(14, 35, 56, 0.4)' : 'none',
                borderRadius: avatarStyle === 'circle' ? '50%' : '12px',
                overflow: 'hidden',
                border: profilePicture ? '2.5px solid white' : 'none',
                width: '45px',
                height: '45px'
            }}>
            {image ? (
                profilePicture ? (
                    <Avatar
                        src={image}
                        alt="profile"
                        sx={{
                            width: avatarStyle === 'circle' ? '40px' : '45px',
                            height: avatarStyle === 'circle' ? '40px' : '45px',
                            backgroundColor: '#9ea9b9',
                            opacity: isSuspended ? 0.5 : 1,
                            borderRadius: avatarStyle === 'circle' ? '50%' : '12px'
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: '45px',
                            height: '45px',
                            borderRadius: avatarStyle === 'circle' ? '50%' : '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            boxShadow: 'none'
                        }}>
                        <img src={image} alt="profile" style={{ width: '100%', height: '100%' }} />
                    </Box>
                )
            ) : (
                <Box
                    sx={{
                        width: '45px',
                        height: '45px',
                        borderRadius: avatarStyle === 'circle' ? '50%' : '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        boxShadow: 'none'
                    }}>
                    <IconSpinner />
                </Box>
            )}
        </Stack>
    )
})

export default GenealogyProfilePicture
